<template>
  <div class="container">
    <h1>Infogande sortering</h1>

    <p>Tidskomplexitet i värsta fall: O(n<sup>2</sup>)<br>
        Tidskomplexitet i bästa fall: O(1)</p>
    <div id="sifferfält">
    <div class="utanförSiffra" v-for="(item, index) in lista" :key="index">

    <div class="sifferbehållare" :style="'left:'+(index*85)+'px;top:85px;'">
       <div class="siffra" :id="index" >
           {{ item }}
       </div>

   </div>


   <!--
   <div class="i">i</div>
   <div class="n">n</div>  -->
<div class="index-nummer" :style="'left:'+(index*85+40)+'px;top:180px;'">[{{index}}]</div>
</div>

<div id="n-pos"><b>n</b></div>


</div>
<!--div id="tempfält">

    <div id="temp-ram" >
<div id="temp-inre">kuk</div>
</div>
</div-->
<div id="klart" style="color:black;">Listan är sorterad</div>

<br><br>


<!--button v-on:click="sortera2()">Bubbel-Sortera manuellt</button-->
<div id="knapprad">
<button v-on:click="auto()">&#9654;</button>

<button v-on:click="pause()"> &#9208; </button>

<button v-on:click="blanda()">Blanda</button>
</div>

<br>
<div id="kodfält">

public void SorteraInfogande (int [] lista)<br>
{<br>
    {{'\xa0 \xa0'}}int i, n;<br>
    {{'\xa0 \xa0'}}int length = lista.Length; if (length n&#60; 2) return;<br>
    {{'\xa0 \xa0'}}int temp;<br><br>
     {{'\xa0 \xa0'}} for ( n=1 ; n n&#60; length; n++) <br>
     {{'\xa0 \xa0'}} {<br>
     {{'\xa0 \xa0 \xa0 \xa0'}} temp = lista[n];<br>
    {{'\xa0 \xa0 \xa0 \xa0'}} i = n-1;<br><br>
     {{'\xa0 \xa0 \xa0 \xa0'}} while ( i>=0 &#38;&#38; lista[i] > temp ) <br>
     {{'\xa0 \xa0 \xa0 \xa0'}} {<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} lista[i+1] = lista[i];<br>
    {{'\xa0 \xa0 \xa0 \xa0 \xa0 \xa0'}} i--;<br>
    {{'\xa0 \xa0 \xa0 \xa0'}} }<br><br>
    {{'\xa0 \xa0 \xa0 \xa0'}} lista[i+1] = temp;<br>
    {{'\xa0 \xa0'}} }<br>
}<br>


</div>
<!--div id="källa"><i>Programmering 1</i>, Magnus Lilja, Ulrik Nilsson, Gleerups 2012, s.192</div-->
<br>
  </div>


</template>

<script>
export default {
  name: 'InfogandeSortering',
  props: {
    msg: String,
    lista : Array
    //n:Number,
    //m:Number //lista.length-1
},
data() {
    return {
        i:0,
        n:1,
        lenght:7, //arrayens längd
        temp:0,
        sune:Function,
        tempBehållare:Object,
        höjd: Boolean,
        behövsUppdatera:Boolean
    }


},
methods: {
    sortera:function() {
        if (this.n>=7) {
            document.getElementById('klart').style.display="block";
            clearInterval(this.sune);

            return;
        }

        //om inget objekt höjts
        if(!this.höjd) {

        if(this.behövsUppdatera) {
            this.organiseraOm();
            return
        } else {
            for (var i=0; i<7;i++) {
                var tillf = document.getElementById(i);
                tillf.parentNode.style.transition="left 0.5s, top 0.5s";

            }
        }


        this.tempBehållare = this.hämtaBehållare2(this.n);//hämtar objekt att lyfta
        this.tempBehållare.style.top = "0"; //lyfter objektet
        this.höjd = true;
        return;
        }


        if (this.höjd) {


            if(this.lista[this.i]>this.temp) { //om uppe och behöver växla med undre


                if(this.i<0) { // inte säkert denna skall ligga här

                    return;
                }


                var current = this.tempBehållare.style.left;
                this.tempBehållare.style.left= 'calc(' + current + ' - 85px)';

                //flytta underliggande åt höger
                //var attKöraHöger = this.hämtaBehållare2(this.n-1);//hämtar objekt köra höger
                var attKöraHöger = this.hämtaBehållare2(this.i);//hämtar objekt köra höger
                attKöraHöger.style.left= (this.i+1)*85+'px';


                this.lista[this.i+1]= this.lista[this.i];
                //this.lista[this.i]=-100;
                this.i--;
                return
            }

            if(this.lista[this.i]<=this.temp) { // om uppe men skall ner igen pga vänser lika eller mindre
                this.tempBehållare.style.top = "85px"; //sänker objektet
                this.behövsUppdatera=true;

                this.höjd = false;
                this.lista[this.i+1] = this.temp;

                this.n++; //som är uppe i for-loopen
                this.temp= this.lista[this.n]
                this.i = this.n-1;
                return
            }


        }

        if(this.i<0) { //om redan längst till vänster
            this.tempBehållare.style.top = "85px"; //sänker objektet
            this.behövsUppdatera=true;
            this.höjd = false;

            this.lista[this.i+1] = this.temp;////????

            this.n++; //som är uppe i for-loopen
            this.temp= this.lista[this.n]
            this.i = this.n-1;
            return
        }


    },
    organiseraOm:function(){
        for (var i=0; i<7;i++) {
            var tillf = document.getElementById(i);
            tillf.parentNode.style.transition="none";
            tillf.parentNode.style.left=(i*85) +'px';
            tillf.innerHTML=this.lista[i];
            this.behövsUppdatera=false;


        }
        document.getElementById('n-pos').style.left=(this.n*85+40)+"px";
    },
    görListanFrånBubblor: function() {
        for(var i=0; i<7;i++) {

            var veronika = this.hämtaBehållare(i);


            var siffra= veronika.firstChild.innerHTML;
            this.lista[i]= parseInt(siffra);
        }
        this.behövsUppdatera=false;
    },

    hämtaBehållare: function(n) {
        console.log("kkkk");
        for(var i=0; i<7;i++) {
            var otto = document.getElementById(i);

            if(otto.parentElement.style.left==(n*85)+'px') {

                return otto.parentElement;
            }
        }
    },

    hämtaBehållare2: function(n) {


            var otto = document.getElementById(n);

            return otto.parentElement;


    },


    blanda:function() {
        document.getElementById('klart').style.display="none";
        this.n=1;//ska va 1
        this.i=0;
        this.lista.forEach((item,i )=> {
            this.lista[i]= Math.floor(Math.random() * 100);
            var temp= document.getElementById(i);
            temp.innerHTML=this.lista[i];
            //temp.parentElement.style.backgroundColor = "#bb0";
        })

        this.temp=this.lista[this.n];
        this.höjd=false;
        this.behövsUppdatera=true;
    },

    pause: function() {
        clearInterval(this.sune);
    },
    auto: function() {

        var that=this;
        this.sune = setInterval(function() {
            that.sortera()}, 1000);
    }
},
created() {
    document.title = 'Infogande sortering';
},
mounted() {
    this.blanda();

},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  margin: 0px;
  padding: 10px;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.sifferbehållare {
    position: absolute;
    border-radius: 50px;
    background-color: #bbb;
    border-style: solid;
    ddisplay: inline-block;
    height: 80px;
    width: 80px;
    transition: left 0.5s, top 0.5s;
}

#sifferfält {

    position: relative;
    display: inline-block;

    width: 600px;
    height: 220px;
}

#källa {
    font-size: 0.8em;
}


.index-nummer {
    position:absolute;
}


.siffra {
    font-size: 3em;
    padding-top:10px;

}
.container {
    min-height: 110vh;
}

#klart {
    display:none;
}

.i{
    color:white;
    transition: color 1s;
}

.n{
    color:white;
    transition: color 1s;
}

#kodfält {
    display: inline-block;
    text-align: left;
    background-color: lightgrey;
    padding: 1em;
    font-family: 'Courier New', monospace;
}
.container {
    background-color: beige;
}

#tempfält {
position: relative;
width:100%;
background-color: black;

}

#temp-ram {
    border-radius: 30px;
    background-color: #bb0;
    border-style: solid;

    height: 80px;
    width: 80px;

    position:absolute;
    color:black;


}

#n-pos {
    position: absolute;
    top:200px;
    color: black;
    left:125px;
    font-family: "Times New Roman", Times, serif;
}

</style>
